export const scrollToSection = ({ currentSection, anchorId }) => {
  const target = anchorId
    ? document.getElementById(anchorId)
    : currentSection?.nextElementSibling

  if (!target) return

  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  })
}

export const handleScroll = (e, anchorId) => {
  const currentSection = e.currentTarget.closest('section')
  scrollToSection({ currentSection, anchorId })
}
